import { render, staticRenderFns } from "./orderdetails.vue?vue&type=template&id=6ee1a0da&scoped=true&"
import script from "./orderdetails.vue?vue&type=script&lang=js&"
export * from "./orderdetails.vue?vue&type=script&lang=js&"
import style0 from "./orderdetails.vue?vue&type=style&index=0&id=6ee1a0da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee1a0da",
  null
  
)

export default component.exports